<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div *ngIf="objectChoosing?.component !== 'AtwIndexNumber'" class="field-row">
        <div class="config-name mt-2" style="gap:10px">
          <p class="m-0" style="line-height:1.5">{{"hien_thi_so_dong" | translate}} </p>
          <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1" [ngStyle]="{ width: '40%' }"
            [(ngModel)]="class['text-name__content']['-webkit-line-clamp']" (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
      </div>
      <div class="field-row">
        <!-- Kiểu văn bản-->
        <div class="config-font" style="width:100%">
          <mat-form-field style="width:100%">
            <mat-label>{{'kieu_van_ban' | translate}}</mat-label>
            <mat-select [(ngModel)]="config['text_type']" (ngModelChange)="handleSetTextStyle($event)">
              <mat-option *ngFor="let item of text_style" [value]="item.name"
                [style.font-size.px]="item.font">{{item.title | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Giải thích kiểu vãn bản -->
        <div class="explain-text-type">
          <ul class="explain-text-type__list">
            <li *ngFor="let item of seoTextTypes" style="font-size: 14px">
              <ng-container *ngIf="item.tag">
                - <b>{{ item.tag | translate }}</b> &#8594;
              </ng-container>
              <span>
                {{ item.explain | translate }} 
                <ng-container *ngIf="item.usage">
                  (<b style="color: red">{{ item.usage | translate }}</b>)
                </ng-container>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
        [config]="config"  [staticdata]="staticdata"
        [textContentClass]="class['text-name__content']" [textWrapperClass]="class['text-name__wrapper']">
      </app-text-format-config>
      <div class="config-name">
        <p>{{'xuong_dong' | translate}}</p>
        <nz-switch [ngModel]="class['text-name__wrapper']['white-space'] && class['text-name__wrapper']['white-space'] !== 'nowrap'"
        (ngModelChange)="class['text-name__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
      </div>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header mt-0" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
       <!-- Cấu hình thông số cơ bản của button-->
       <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu9"
       (nzOpenChange)="openHandler('menu9')">
       <div class="button-size">
         <!-- Lựa chọn hiển thị cho các thiết bị -->
         <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
         </app-hide-show-config>
       </div>
     </li>
      <!-- Cấu hình tái sử dụng thiết kế-->


      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">

            <div *ngIf="objectChoosing?.component !== 'AtwIndexNumber'" class="field-row">
              <div class="config-name mt-2" style="gap:10px">
                <p class="m-0" style="line-height:1.5">{{"hien_thi_so_dong" | translate}} </p>
                <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1" [ngStyle]="{ width: '40%' }"
                  [(ngModel)]="class['text-name__content']['-webkit-line-clamp']" (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
            </div>
            <div class="field-row">
              <!-- Kiểu văn bản-->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>{{'kieu_van_ban' | translate}}</mat-label>
                  <mat-select [(ngModel)]="config['text_type']" (ngModelChange)="handleSetTextStyle($event)">
                    <mat-option *ngFor="let item of text_style" [value]="item.name"
                      [style.font-size.px]="item.font">{{item.title | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Giải thích kiểu vãn bản -->
              <div class="explain-text-type">
                <ul class="explain-text-type__list">
                  <li *ngFor="let item of seoTextTypes" style="font-size: 14px">
                    <ng-container *ngIf="item.tag">
                      - <b>{{ item.tag | translate }}</b> &#8594;
                    </ng-container>
                    <span>
                      {{ item.explain | translate }} 
                      <ng-container *ngIf="item.usage">
                        (<b style="color: red">{{ item.usage | translate }}</b>)
                      </ng-container>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config"  [staticdata]="staticdata"
              [textContentClass]="class['text-name__content']" [textWrapperClass]="class['text-name__wrapper']">
            </app-text-format-config>
            <div class="config-name">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch [ngModel]="class['text-name__wrapper']['white-space'] && class['text-name__wrapper']['white-space'] !== 'nowrap'"
              (ngModelChange)="class['text-name__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
            </div>
            <!-- Gradient -->
            <div class="config-font">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <p class="m-0" style="line-height:1.5">{{"do_mau_gradient" | translate}}<span style="font-size:13px">({{"da_sac" | translate}})</span></p>
                <nz-switch [(ngModel)]="config['background-image'].gradient_check"
                  (ngModelChange)="handleSetGradientText()">
                </nz-switch>
              </div>
              <div class="container-gradient" *ngIf="config['background-image'].gradient_check">
                <div class="list-gradient">
                  <button class="btn-gradient"
                    *ngFor="let bgGradient of config['background-image']['gradient_arr_gradient']; let i = index"
                    (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                    [disabled]="!config['background-image'].gradient_check">
                    <i class="delete-icon bi bi-x-circle"></i>
                  </button>
                </div>
                <p class="title-head">{{"them_mau" | translate}}</p>
                <div class="container_add-gradient">
                  <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                    [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                    (blur)="addGradient()">
                    <input nz-input type="color" class="picking-gradient" id="input-gradient"
                      [(ngModel)]="config['background-image']['gradient_background_color']">
                    <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                  </button>
                  <div class="slide_container-gradient">
                    <input type="range" min="1" max="100" [value]="config['background-image']['gradient_opacity']"
                      class="slider-gradient" (input)="getValueRangeBackgroundGradient($event)"
                      [disabled]="!config['background-image'].gradient_check"
                      [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                  </div>
                  <div class="value-range">{{config['background-image']['gradient_opacity']}}%</div>
                </div>
                <p class="title-head">{{"huong_phoi_mau" | translate}}</p>
                <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
                  [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                  [disabled]="!config['background-image'].gradient_check"
                  [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                  [ngClass]="{ 'active': config['background-image']['gradient_direction'] === type.direction}">
                </button>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{"khoang_cach_chu" | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['text-name__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['text-name__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['text-name__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['text-name__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{"khoang_cach_dong" | translate}}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['text-name__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                        [(ngModel)]="this.class['text-name__content']['line-height']" (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config [config]="config" [class]="class" [staticdata]="staticdata" [device]="device"
          [objectChoosing]="objectChoosing" [textContentClass]="class['text-name__content']"
          [textWrapperClass]="class['text-name']" [filterConfig]="config['text-shadow']" [isShape]="false">
        </app-text-style-config>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['text-name__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text-name__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['text-name']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>
      <!-- THÊM LIÊN KẾT -->
      <li nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-link-page-config [type_page]="['detail_product']"  [objectChoosing]="objectChoosing"  [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>

      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['text-name__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>
